/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Routemize_DTOs_AuthenticatorSetupDto } from '../models/Routemize_DTOs_AuthenticatorSetupDto';
import type { Routemize_DTOs_EnableTwoFactorResultDto } from '../models/Routemize_DTOs_EnableTwoFactorResultDto';
import type { Routemize_DTOs_RecoveryCodesDto } from '../models/Routemize_DTOs_RecoveryCodesDto';
import type { Routemize_DTOs_SendSmsVerificationDto } from '../models/Routemize_DTOs_SendSmsVerificationDto';
import type { Routemize_DTOs_TwoFactorStatusDto } from '../models/Routemize_DTOs_TwoFactorStatusDto';
import type { Routemize_DTOs_VerifyAuthenticatorDto } from '../models/Routemize_DTOs_VerifyAuthenticatorDto';
import type { Routemize_DTOs_VerifySmsCodeDto } from '../models/Routemize_DTOs_VerifySmsCodeDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class TwoFactorService {
    /**
     * @returns Routemize_DTOs_TwoFactorStatusDto OK
     * @throws ApiError
     */
    public static getApiAppTwoFactorGetStatus(): CancelablePromise<Routemize_DTOs_TwoFactorStatusDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/twoFactor/getStatus',
        });
    }
    /**
     * @returns Routemize_DTOs_AuthenticatorSetupDto OK
     * @throws ApiError
     */
    public static postApiAppTwoFactorSetupAuthenticator(): CancelablePromise<Routemize_DTOs_AuthenticatorSetupDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/twoFactor/setupAuthenticator',
        });
    }
    /**
     * @param requestBody
     * @returns Routemize_DTOs_EnableTwoFactorResultDto OK
     * @throws ApiError
     */
    public static postApiAppTwoFactorVerifyAuthenticator(
        requestBody?: Routemize_DTOs_VerifyAuthenticatorDto,
    ): CancelablePromise<Routemize_DTOs_EnableTwoFactorResultDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/twoFactor/verifyAuthenticator',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAppTwoFactorSendSmsCode(
        requestBody?: Routemize_DTOs_SendSmsVerificationDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/twoFactor/sendSmsCode',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns Routemize_DTOs_EnableTwoFactorResultDto OK
     * @throws ApiError
     */
    public static postApiAppTwoFactorVerifySms(
        requestBody?: Routemize_DTOs_VerifySmsCodeDto,
    ): CancelablePromise<Routemize_DTOs_EnableTwoFactorResultDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/twoFactor/verifySms',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAppTwoFactorDisable(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/twoFactor/disable',
        });
    }
    /**
     * @returns Routemize_DTOs_RecoveryCodesDto OK
     * @throws ApiError
     */
    public static postApiAppTwoFactorRegenerateRecoveryCodes(): CancelablePromise<Routemize_DTOs_RecoveryCodesDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/twoFactor/regenerateRecoveryCodes',
        });
    }
}
